import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const DetailedViewIcon = (props: IconProps) => (
  <Icon viewBox="0 0 18 20" boxSize={5} {...props}>
    <path
      d="M17 1C17.5523 1 18 1.44772 18 2C18 2.55228 17.5523 3 17 3H1C0.447715 3 0 2.55228 0 2C0 1.44772 0.447715 1 1 1H17Z"
      fill="currentColor"
    />
    <path
      d="M17 6C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H1C0.447715 8 0 7.55228 0 7C0 6.44772 0.447715 6 1 6H17Z"
      fill="currentColor"
    />
    <path
      d="M17 11C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H1C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H17Z"
      fill="currentColor"
    />
    <path
      d="M17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18H1C0.447715 18 0 17.5523 0 17C0 16.4477 0.447715 16 1 16H17Z"
      fill="currentColor"
    />
  </Icon>
);

export default DetailedViewIcon;
